module.exports = __webpack_public_path__ + "img/logo_wethrivehub.513f281e.png";